import React, { useState } from 'react'
import { css } from '@emotion/core'
import { colors, Icon, Input, Modal, Tag, Typography } from '@dw/helix'
import { ScanItem } from '../Scan'

export interface ArticleSerialSearchModalComponentProps {
  scanItem: ScanItem
  onRemoveSerialNumber: (articleId: string, serialNumber: string) => void
  onClose: () => void
}

const articleSerialSearchModalStyles = css`
  margin-top: 116px;
`

const icoLeftStyles = css`
  fill: ${colors.brandBlue};
  height: 20px;
  width: 30px;
  flex-shrink: 0;
  padding-left: 12px;
  margin-bottom: 1px;
`
const rowStyles = css`
  :not(:last-of-type) {
    margin-bottom: 20px;
  }
`
const overviewRowStyles = css`
  ${rowStyles}
  display: flex;
  flex-direction: row;
  > * {
    margin-right: 20px;
  }
`

const serialTagRowStyles = css`
  ${rowStyles}
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-gap: 10px;
`

const tagStyles = css`
  max-width: none;
  width: 100%;
`
const needAttentionStyles = css`
  color: white;
  max-width: none;
  width: 100%;
  background: #D80000;
  `

const ArticleSerialSearchModal = ({
  scanItem,
  onRemoveSerialNumber,
  onClose,
}: ArticleSerialSearchModalComponentProps) => {
  const [searchQueryInState, setSearchQueryInState] = useState<string>('')
  const { articleId, serialNumbers, needAttention, traces } = scanItem
  const searchedSerialNumbers = serialNumbers.filter(serialNumber => {
    return !searchQueryInState || serialNumber.includes(searchQueryInState)
  })
  return (
    <Modal title="Scanned Products" onClose={onClose} css={articleSerialSearchModalStyles}>
      {() => (
        <>
          <div css={overviewRowStyles}>
            <Typography type="h4">Article No: {articleId}</Typography>
            <Typography type="h4">Previous: {traces.length}</Typography>
            <Typography type="h4">Current: {serialNumbers.length}</Typography>
          </div>
          <div css={rowStyles}>
            <Input
              value={searchQueryInState}
              label="Search for serials scanned in this session"
              onChange={(event: React.ChangeEvent<HTMLInputElement>) => setSearchQueryInState(event.target.value)}
              type="search"
              icoLeft={<Icon name="search" css={icoLeftStyles} />}
            />
          </div>
          <div css={serialTagRowStyles}>
            {searchedSerialNumbers.map((searchedSerialNumber, index) => (
              <Tag
                key={searchedSerialNumber + index}
                onClose={() => onRemoveSerialNumber(articleId, searchedSerialNumber)}
                size="medium"
                text={searchedSerialNumber}
                theme="light"
                css={needAttention.includes(searchedSerialNumber)? needAttentionStyles: tagStyles}
              />
            ))}
          </div>
        </>
      )}
    </Modal>
  )
}

export default ArticleSerialSearchModal
